module.exports = __webpack_public_path__ + "media/icons/favourite-yes@2x-a9372c69.png";